// extracted by mini-css-extract-plugin
module.exports = {"bigProgressButton":"big-progress-button_bigProgressButton__3w-Pp","progress":"big-progress-button_progress__77OLD"};